const state = {
    collapse: false,
    field_active: `1`,
    reset: false
}

const mutations = {
    SET_COLLAPSE: (state, collapse) => {
        state.collapse = collapse
    },
    SET_FIELD_ACTIVE: (state, v) => {
        state.field_active = v
    },
    SET_RESET: (state, v) => {
        state.reset = v
    }
}

const actions = {}

const getters = {
    collapse: (state, getters) => {
        return state.collapse
    },
    field_active: (state, getters) => {
        return state.field_active
    },
    reset: (state, getters) => {
        return state.reset
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js